import { render } from "./RecieversGroupAddComponent.vue?vue&type=template&id=5330b998&scoped=true"
import script from "./RecieversGroupAddComponent.vue?vue&type=script&lang=js"
export * from "./RecieversGroupAddComponent.vue?vue&type=script&lang=js"

import "./RecieversGroupAddComponent.vue?vue&type=style&index=0&id=5330b998&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5330b998"]])

export default __exports__